import React, { useEffect, useState } from "react";
import { dispatch } from "store";
import {
  locationStockSelector,
  getLocationStockThunk,
  resetStat,
} from "store/reducers/inventory/stock/locationStockSlice";
import { useSelector } from "react-redux";
import TransferLocationStock from "./menu/TransferLocationStock";
import ReturnLocationStock from "./menu/ReturnLocationStock";
import { Box, Button, Stack } from "@mui/material";
import StockListCommons from "pages/inventory/StockListCommons";
import AutoCompleteList from "components/AutoCompleteList";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";
import { useNavigate } from "react-router-dom";
import RemoveLocationStock from "./menu/RemoveLocationStock";

const LocationStockList = () => {
  useEffect(() => {
    dispatch(getLocationStockThunk());
  }, []);
  const navigate = useNavigate();
  const roles = useSelector((state) => state.auth.user.roles);
  const items = useSelector(locationStockSelector.selectAll);
  const [returnOpen, setReturnOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);
  const [stock, setStock] = useState(null);
  const openMainStockReturn = (item) => {
    setReturnOpen(true);
    setStock(item);
  };
  const openTransfer = (item) => {
    setTransferOpen(true);
    setStock(item);
    dispatch(resetStat());
  };

  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  const locations = useSelector(locationSelector.selectAll);
  const [location, setLocation] = useState(null);
  useEffect(() => {
    if (location) {
      dispatch(getLocationStockThunk(location.id));
    }
  }, [location]);
  const inventorySetting = useSelector((state) => state.inventorySettings.data);

  const openRemove = (item) => {
    setRemoveOpen(true);
    setStock(item);
    dispatch(resetStat());
  };

  return (
    <Box padding={3}>
      <Stack marginBottom={2} direction="row" justifyContent="space-between">
        {roles.includes("super_admin", "admin", "distributor") && (
          <Box width={300}>
            <AutoCompleteList
              items={locations}
              name="name"
              label="Filter kitchen"
              setValue={setLocation}
              value={location}
            />
          </Box>
        )}
        <Button
          variant="outlined"
          onClick={() => {
            navigate(location ? `logs?location=${location.id}` : "logs");
          }}
        >
          View transaction logs
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate(location ? `history?location=${location.id}` : "history");
          }}
        >
          View stock history
        </Button>
      </Stack>
      <StockListCommons
        items={items}
        openStockReturn={openMainStockReturn}
        openTransfer={openTransfer}
        stock={stock}
        returnOpen={returnOpen}
        removeOpen={removeOpen}
        openRemove={openRemove}
        transferOpen={transferOpen}
        setReturnOpen={setReturnOpen}
        setRemoveOpen={setRemoveOpen}
        setTransferOpen={setTransferOpen}
        ReturnStock={ReturnLocationStock}
        TransferStock={TransferLocationStock}
        hasEditPermissions={roles.includes("location_admin")}
        disableTransfer={false}
        disableReturn={inventorySetting?.stock_level === "location"}
        RemoveStock={RemoveLocationStock}
      />
    </Box>
  );
};

export default LocationStockList;
